import { createFileRoute } from "@tanstack/react-router";
import { getSharedCoworld } from "@/features/coworlds/records";
import { CreatorUpload } from "@/features/coworlds/upload";

export const Route = createFileRoute("/_site/coworlds/$name/")({
  loaderDeps: ({ search }) => search,
  loader: ({ params, location, abortController }) =>
    getSharedCoworld({
      name: params.name,
      search: location.searchStr,
      signal: abortController.signal,
    }),
  head: ({ loaderData }) => ({
    meta: [{ title: `${loaderData?.name ?? "Coworld"} · Softmax` }],
  }),
  component: function SharedCoworldPage() {
    return <CreatorUpload data={Route.useLoaderData()} />;
  },
});
